import { useMutation, useQueryClient } from '@tanstack/react-query'

import { queryKey as aansluitingQueryKey } from '../../aansluiting/contractinstellingen/hooks/useTemplatesSearch'
import { queryKey as hoofdleidingQueryKey } from '../../hoofdleiding/contractinstellingen/hooks/useTemplatesSearch'
import { useAlerts } from '../../theme/hooks/useAlerts'
import { patchBijlageTemplate } from '../services/patchBijlageTemplate'
import type { BijlageTemplate } from '../types/BijlageTemplate'
import { mergeBijlageTemplate } from '../util'

export { useUpdateBijlageTemplate }

const useUpdateBijlageTemplate = () => {
  const queryClient = useQueryClient()
  const { successAlert } = useAlerts()

  return useMutation({
    mutationFn: patchBijlageTemplate,
    onSuccess: (_, { bijlageTemplate }) => {
      queryClient.setQueriesData(
        { queryKey: [aansluitingQueryKey] },
        (
          cachedTemplates: { bijlageTemplates: BijlageTemplate[] } | undefined,
        ) => {
          if (!cachedTemplates) return cachedTemplates
          return {
            ...cachedTemplates,
            bijlageTemplates: cachedTemplates.bijlageTemplates.map((o) =>
              o._id === bijlageTemplate._id
                ? mergeBijlageTemplate(o, bijlageTemplate)
                : o,
            ),
          }
        },
      )
      queryClient.setQueriesData(
        { queryKey: [hoofdleidingQueryKey] },
        (
          cachedTemplates: { bijlageTemplates: BijlageTemplate[] } | undefined,
        ) => {
          if (!cachedTemplates) return cachedTemplates
          return {
            ...cachedTemplates,
            bijlageTemplates: cachedTemplates.bijlageTemplates.map((o) =>
              o._id === bijlageTemplate._id
                ? mergeBijlageTemplate(o, bijlageTemplate)
                : o,
            ),
          }
        },
      )
      successAlert('Bijlage template successvol opgeslagen')
    },
  })
}
